import { useState } from "react";
import { Grid3x3 } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { imgUrl } from "@/lib/api";
import { PhotoTour } from "./PhotoTour";

const Tile = ({ p, className, onClick, testid }) => (
  <button onClick={onClick} data-testid={testid} className={`group relative overflow-hidden bg-[#E8D8C3] ${className}`}>
    <img src={imgUrl(p?.url)} alt={p?.caption || ""} loading="lazy" className="h-full w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.06]" />
    <span className="absolute inset-0 bg-ink/0 transition-colors duration-500 group-hover:bg-ink/15" />
  </button>
);

export const Bento = ({ prop }) => {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);
  const [start, setStart] = useState(null);
  const photos = Array.isArray(prop?.photos) ? prop.photos : [];
  const off = photos.length > 5 ? 1 : 0;
  const five = photos.slice(off, off + 5);
  const show = (i) => { setStart(i); setOpen(true); };
  if (!photos.length) return null;
  return (
    <div id="gallery" className="relative">
      <div className="-mx-5 flex snap-x snap-mandatory gap-3 overflow-x-auto px-5 pb-2 md:hidden" data-testid="gallery-mobile-strip">
        {photos.slice(0, 10).map((p, i) => (
          <Tile key={i} p={p} testid={`gallery-mobile-${i}`} onClick={() => show(i)} className="aspect-[4/3] w-[85%] shrink-0 snap-center rounded-2xl" />
        ))}
      </div>
      <div className="hidden h-[520px] grid-cols-4 grid-rows-2 gap-3 overflow-hidden rounded-[28px] md:grid" data-testid="gallery-bento">
        {five.map((p, i) => (
          <Tile key={i} p={p} testid={`gallery-tile-${i}`} onClick={() => show(i + off)} className={i === 0 ? "col-span-2 row-span-2" : "col-span-1 row-span-1"} />
        ))}
      </div>
      <button
        data-testid="show-all-photos-button"
        onClick={() => show(null)}
        className="mt-4 flex items-center gap-2 rounded-full border border-ink/20 bg-paper px-5 py-2.5 text-sm font-medium text-ink shadow-sm transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-white md:absolute md:bottom-6 md:right-6 md:mt-0"
      >
        <Grid3x3 className="h-4 w-4" /> {t("l.showAll")} ({photos.length})
      </button>
      <PhotoTour open={open} onOpenChange={setOpen} photos={photos} start={start} />
    </div>
  );
};
